<svg width="48" height="28" viewBox="0 0 48 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="48" height="28" rx="4" fill="#ffffff" />
  <circle cx="19" cy="14" r="7" fill="#EB001B" />
  <circle cx="29" cy="14" r="7" fill="#F79E1B" fill-opacity="0.85" />
</svg>
